import { combineLatest, map } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { presentationMode$ } from './presentationMode$';
import { activeFilter$ } from 'streams/filters/activeFilter$';
import { components$ } from 'streams/components/components$';
import { context$ } from 'streams/context/context$';

import { componentInterface } from '@ardoq/component-interface';
import { isViewpointMode$ } from '../../traversals/loadedGraph$';
import { loadedState$ } from '../../loadedState/loadedState$';
import { Features, hasFeature } from '@ardoq/features';
import { isDiscoverJourney } from 'canvas/isDiscoverJourney';
import { i18nLocale$ } from 'streams/i18nLocale$';

const workspaceId$ = context$.pipe(
  map(context => context.workspaceId),
  distinctUntilChanged()
);

const emptyView$ = combineLatest([
  workspaceId$,
  presentationMode$,
  activeFilter$,
  isViewpointMode$,
  loadedState$,
  components$,
  i18nLocale$,
]).pipe(
  map(
    ([
      workspaceId,
      presentationMode,
      activeFilter,
      { isViewpointMode },
      { loadedStates },
      ,
      i18nLocale,
    ]) => {
      const isCanvas =
        (isDiscoverJourney() || hasFeature(Features.CANVAS_PROTOTYPE)) &&
        isViewpointMode;
      return {
        isPresentationMode: presentationMode.isPresentationMode,
        hasActiveFilter: Boolean(
          activeFilter.activeFilters?.componentRules.rules?.length ||
          activeFilter.activeFilters?.referenceRules.rules?.length
        ),
        isWorkspaceEmpty: componentInterface.isWorkspaceEmpty(workspaceId),
        isCanvasNoSelection: isCanvas && !loadedStates.length,
        isCanvasEmpty:
          isCanvas &&
          loadedStates.length > 0 &&
          loadedStates[0].componentIdsAndReferences.componentIds.length === 0,
        i18nLocale,
      };
    }
  )
);

export { emptyView$ };
